import { useCallback, useState as _useState } from 'react'


const useState = (initialState) => {
  const [ state, _setState ] = _useState(initialState)

  const setState = useCallback((value) => {
    if (!value || Array.isArray(value) || typeof value !== 'object' && typeof value !== 'function') {
      return _setState(value)
    }

    return _setState((prevState) => ({ ...prevState, ...(typeof value === 'function' ? value(prevState) : value) }))
  }, [])

  return [ state, setState ]
}


export default useState
